/**
 * React Query Client Configuration for V4 Dashboard
 */

import { QueryClient } from '@tanstack/react-query'

// V4 Dashboard-specific query client with optimized defaults
export let dashboardQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // No caching to prevent cross-session issues
      staleTime: 0,
      gcTime: 0,

      // Background refetch settings
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchOnMount: true,

      // Disable retries on error
      retry: false,

      // Network mode
      networkMode: 'online',
    },
    mutations: {
      retry: 1,
      networkMode: 'online',
    },
  },
})

export default dashboardQueryClient
